import { t } from 'Locale/index';

export const episodesGrammarTranslationKeys = Object.freeze({
    singleKey: 'COMMON.EPISODE',
    lessThanFourKey: 'COMMON.EPISODES',
    moreThanFourKey: 'COMMON.EPISODES_GRAMMAR'
});

export const seriesGrammarTranslationKeys = Object.freeze({
    singleKey: 'COMMON.SEASON',
    lessThanFourKey: 'COMMON.SEASONS',
    moreThanFourKey: 'COMMON.SEASONS_GRAMMAR'
});

export const getGrammarCountString = (count, keys) => {
    if (count && keys) {
        if (count > 1 && count < 4) {
            return `${count} ${t(keys.lessThanFourKey)}`;
        }
        if (count === 1) {
            return `1 ${t(keys.singleKey)}`;
        }
        return `${count} ${t(keys.moreThanFourKey)}`;
    }
    return '';
};
